var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"section-box",staticStyle:{"padding-top":"60px"}},[_c('v-card',{staticClass:"d-flex",attrs:{"height":"100%"}},[(_vm.src)?_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.src,"frameborder":"0"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }